export default function Live() {
    return (
        <iframe
            src='https://meumundom.pages.net.br/live-commerce-aovivo'
            width='100%'
            height='1500px'
            frameBorder='0'
        />
    )
}
